import React from 'react';

const ArrowIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Back to top</title>
    <path
      d="M7.28125 3.3125C7.65625 2.90625 8.3125 2.90625 8.6875 3.3125L14.6875 9.3125C15.0938 9.6875 15.0938 10.3438 14.6875 10.7188C14.3125 11.125 13.6562 11.125 13.2812 10.7188L8 5.4375L2.6875 10.7188C2.3125 11.125 1.65625 11.125 1.28125 10.7188C0.875 10.3438 0.875 9.6875 1.28125 9.3125L7.28125 3.3125Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowIcon;
